/* Handlekurven og skuffen. Lastes på alle sider (fra snippets/cart-drawer.liquid),
   siden skuffen ligger på alle sider.

   1. Enter i antallsfeltet sendte kunden til kassen.

      KASSE er eneste submit-knapp i kurvskjemaet, og blir da skjemaets
      «standardknapp»: Enter i et felt i skjemaet trykker på den. På /cart sendes
      POST /cart med «updates[]=1&checkout=», og i skuffen endret adressen seg til
      /checkouts/cn/…. På mobil er det «Gå» på tastaturet som gjør det, for dem som
      taster inn et antall i stedet for å bruke + og −.

      Løsningen er å ta Enter selv: blur() sender «change», og Dawn oppdaterer
      antallet uten at siden forlates. Gjelder bare feltene i kurvlinjene. Enter i
      antallsfeltet på produktsiden legger fortsatt varen i kurven.

   2. Trygghetsblokken under KASSE på /cart ligger utenfor området Dawn tegner på
      nytt (.js-contents), så den byttes her når kurven er endret. Skuffen tegnes
      på nytt som helhet og trenger ikke dette. */
(function () {
  'use strict';

  document.addEventListener('keydown', (hendelse) => {
    if (hendelse.key !== 'Enter' || hendelse.isComposing) return;
    const felt = hendelse.target;
    if (!(felt instanceof HTMLInputElement) || !felt.matches('.cart-item .quantity__input')) return;
    hendelse.preventDefault();
    felt.blur();
  });

  const byttTrygghet = () => {
    const mal = document.querySelector('main .cart__blocks .gs-trygghet--kompakt');
    const seksjon = document.getElementById('main-cart-footer');
    if (!mal || !seksjon || typeof routes === 'undefined') return;

    fetch(`${routes.cart_url}?section_id=${seksjon.dataset.id}`)
      .then((svar) => svar.text())
      .then((tekst) => {
        const dok = new DOMParser().parseFromString(tekst, 'text/html');
        const ny = dok.querySelector('.cart__blocks .gs-trygghet--kompakt');
        if (ny) mal.innerHTML = ny.innerHTML;
      })
      .catch(() => {});
  };

  const start = () => {
    if (!document.querySelector('main .cart__blocks .gs-trygghet--kompakt')) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, byttTrygghet);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
